import { render, staticRenderFns } from "./AlternateAction.vue?vue&type=template&id=ab37cf50&scoped=true&"
import script from "./AlternateAction.vue?vue&type=script&lang=js&"
export * from "./AlternateAction.vue?vue&type=script&lang=js&"
import style0 from "./AlternateAction.vue?vue&type=style&index=0&id=ab37cf50&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab37cf50",
  null
  
)

export default component.exports